import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const InputDefaultMaskContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const InputDefaultMaskLabel = styled.label`
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.03em;
  color: ${colors.textPrimary};
  opacity: 0.9;
  text-transform: uppercase;
  display: block;
  margin-bottom: 12px;
`;

export const InputDefaultMaskField = styled.input`
  border-radius: 8px;
  border: 1px solid ${colors.textSecondary};
  font-size: 14px;
  padding: 12px 10px;
  cursor: initial;
  transition: ease-in-out .2s;

  &:read-only {
    background: ${colors.readOnlyBorder};
    border: 1px solid ${colors.readOnlyBorder};
  }

  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${colors.textSecondary};
    opacity: 0.9;
    font-size: 14px;
    font-family: 'Montserrat', sans-serif;;
  }

  :-ms-input-placeholder {
    color: ${colors.textSecondary};
    opacity: 0.9;
    font-size: 14px;
    font-family: 'Montserrat', sans-serif;;
  }

  &.error {
    border-bottom: solid 5px ${colors.bgDanger}; 
  }
`;

export const InputDefaultMaskMessageError = styled.small`
  font-size: 12px;
  color: ${colors.bgDanger};
  line-height: 14px;
  margin: 5px 8px;
  opacity: ${prop => prop.error ? '1' : '0'};
  transition: ease-in-out .2s;
`;
